import Api from "../../service";

async function getPlatformAuthLink(params) {
    return await Api.get('/api/v1/Auth/GetPlatformAuthLink',{
        params
    });
}

export default getPlatformAuthLink;